import { FormSchemaAdapter, Resources } from "@validereinc/domain";
import { useGetOne, useGetList } from "./adapterUtils";

export const useGetOneFormSchema = useGetOne(
  FormSchemaAdapter.getOne,
  Resources.FORM_SCHEMA
);

export const useListFormSchemas = useGetList(
  FormSchemaAdapter.getList,
  Resources.FORM_SCHEMA
);
